/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.5.16",
    versionName: "0.2.0-nightly.2026.5.16",
    versionChannel: "nightly",
    buildDate: "2026-05-16T00:29:24.989Z",
    commitHash: "8d34e49ec2ce79087419172d3546151ba4288595",
};
